import { FlexRow, MaterialIcon, StyledButton, StyledSearchBar, useModal } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo, useEffect } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import StyledTooltip from '../../ui/StyledTooltip';
import useMaintenanceTypes from '../hooks/useMaintenanceTypes';
import MaintenanceTypeModal from './MaintenanceTypeModal';

function MaintenanceTypesFiltersBar() {
  const { css, theme } = useStyles();
  const { closeModal, openModal, showModal } = useModal();
  const { onChangeSearch, onReload, resetAllFilters, search } = useMaintenanceTypes();

  useEffect(() => {
    return () => {
      resetAllFilters();
    };
  }, []);

  return (
    <FlexRow
      classNames={css({ alignItems: 'center' })}
      gap={theme.sizing.scale100}
    >
      <FlexRow
        classNames={css({ flex: '1', alignItems: 'center' })}
        gap={theme.sizing.scale100}
      >
        <span className={css({ flexGrow: '0.5' })}>
          <StyledSearchBar
            name="fleet-maintenance-type-search"
            value={search}
            onChange={onChangeSearch}
            clearable
            noMargin
          />
        </span>
      </FlexRow>
      <StyledTooltip
        content="Recargar tabla"
        showArrow={false}
      >
        <Button
          size="compact"
          shape="square"
          onClick={onReload}
          kind="tertiary"
        >
          <MaterialIcon name="refresh" />
        </Button>
      </StyledTooltip>
      <StyledButton
        onClick={openModal}
        startEnhancer={
          <MaterialIcon
            name="add"
            size={theme.sizing.scale600}
            color={theme.colors.contentInversePrimary}
          />
        }
      >
        Nuevo
      </StyledButton>
      <MaintenanceTypeModal
        isOpen={showModal}
        onClose={(update) => {
          if (update) onReload();
          closeModal();
        }}
      />
    </FlexRow>
  );
}

export default memo(MaintenanceTypesFiltersBar);
